<template>
    <div class="d-flex justify-content-center bg-white p-3 ">
        <div class="spinner-border ml-auto text-primary" role="status" aria-hidden="true"></div>
    </div>
</template>
<script>
export default {
    name : 'Loader'
}
</script>